import { AxiosError } from 'axios'
import { useEffect, useState } from 'react'

import { get } from '../../../utils/api'
import { handleApiErrors } from '../../../utils/apiErrors'

interface Context {
  counter: Counter | undefined
  isFetching: boolean
}

export interface Counter {
  id: number
  code: string
  description: string
  isEnabled: boolean
  threshold: number
  currentValue: number
}

export const useTrainingCounterData = (): Context => {
  const [counter, setCounter] = useState<Counter | undefined>(undefined)
  const [isFetching, setIsFetching] = useState(false)

  useEffect(() => {
    setIsFetching(true)
    get<Counter[]>(`/licensing/counters/?code=MAX_TRAININGS`)
      .then((data) => {
        setIsFetching(false)
        if (data.length > 0) {
          setCounter(data[0])
        }
      })
      .catch((errors: AxiosError) => {
        setIsFetching(false)
        handleApiErrors(errors)
      })
  }, [])

  return {
    counter,
    isFetching,
  }
}
